var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Nav'),_c('Hero'),_c('Statistics'),_c('About'),_c('Services'),_c('Influencers'),_c('Posts'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }